import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Sorveglia che nulla copra il pulsante del menu.
 *
 * Ogni tanto il pulsante che apre la barra laterale smette di rispondere e non
 * fa nemmeno l'effetto del tocco: il segno che qualcosa gli sta sopra e
 * intercetta il clic, tipicamente una finestra modale rimasta nel documento
 * dopo un cambio di pagina. Il difetto e' intermittente e dal codice non si
 * riesce a risalire al responsabile, quindi lo si fa dichiarare a chi lo causa:
 * a ogni cambio di rotta si guarda chi c'e' davvero in quel punto dello
 * schermo, e se non e' il pulsante lo si scrive in console con l'elemento
 * incriminato.
 *
 * Solo in sviluppo: in produzione non deve costare nulla.
 */
export const useOverlayWatchdog = () => {
  const location = useLocation();

  useEffect(() => {
    if (process.env.NODE_ENV === 'production') return;

    // dopo il disegno e dopo le animazioni di uscita delle modali
    const timer = setTimeout(() => {
      const bottone = document.querySelector('[aria-label="open drawer"]');
      if (!bottone) return; // non autenticato, o barra non ancora disegnata

      const r = bottone.getBoundingClientRect();
      if (r.width === 0 || r.height === 0) return;

      const sopra = document.elementFromPoint(r.x + r.width / 2, r.y + r.height / 2);
      if (!sopra || bottone.contains(sopra) || sopra.contains(bottone)) return;

      // Se c'e' una finestra davvero aperta, che copra il pulsante e' giusto:
      // segnalarlo comunque riempiva la console di falsi allarmi (bastava il
      // promemoria dei documenti) e avrebbe coperto il difetto vero.
      const apertaPerDavvero = Array.from(document.querySelectorAll('.MuiDialog-root, .MuiDrawer-root'))
        .some((m) => m.getAttribute('aria-hidden') !== 'true'
          && !m.classList.contains('MuiModal-hidden')
          && m.getBoundingClientRect().width > 0);
      if (apertaPerDavvero) return;

      const modali = document.querySelectorAll('.MuiModal-root');
      // eslint-disable-next-line no-console
      console.warn(
        '[menu bloccato] qualcosa copre il pulsante della barra laterale.',
        '\n  elemento sopra:', sopra,
        '\n  sue classi:', (sopra as HTMLElement).className,
        '\n  modali nel documento:', modali.length,
        '\n  stile del body:', document.body.style.cssText || '(nessuno)',
        '\n  rotta:', location.pathname
      );
    }, 400);

    return () => clearTimeout(timer);
  }, [location.pathname]);
};

export default useOverlayWatchdog;
